export * from './user.interface';
export * from './global.interface';


export enum UserRoles {
    ADMIN = 'ADMIN',
    SUBUSER = 'SUBUSER',
}
